import { fromNow } from '@btime/helpers'
import React from 'react'

import { SmallText, Text } from '../../../../components/presentation/Text'
import { useAsset } from '../_load/AssetLoader'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Qrcode from '../../../../containers/qrcodes/Qrcode'
import Separator from '../../../../components/helpers/Separator'
import Center from '../../../../packages/kiti/components/helpers/Center'
import IconBlock from '../../../../components/presentation/IconBlock'
import Panel from '../../../../packages/kiti/components/structure/Panel'
import { HorizontalLine } from '../../../../components/shapes/Line'
import { COLORS } from '@btime/constants'

const QRCODE_SIZE = 165

const Qrcodes = () => {
  const assets = useAsset()

  if (!assets.qrcodes.length) {
    return (
      <FlexGrid justify="center">
        <Center height="100%">
          <IconBlock icon="IoQrCodeOutline" title={'Nenhum QR Code encontrado'} />
        </Center>
      </FlexGrid>
    )
  }

  return (
    <FlexGrid justify="flex-start" align="flex-start" gutter={0.8} wrap>
      {(assets?.qrcodes || []).map(qrcode => (
        <FlexCol width={QRCODE_SIZE} key={qrcode.id}>
          <Panel padding="1rem" flex align="stretch">
            <Qrcode id={qrcode.id} size={QRCODE_SIZE} level="L" />

            <Separator weight={4} />
            <HorizontalLine thin lineColor={COLORS.light3} />
            <Separator weight={2} />
            <Text bold align="center">
              #{qrcode.id}
            </Text>
            <SmallText align="center" size="xsmall">
              Ativado {fromNow(qrcode.updatedAt)}
            </SmallText>
          </Panel>
        </FlexCol>
      ))}
    </FlexGrid>
  )
}

export default Qrcodes
